const nasaspaceapp = () => {
    return (
        <>
            <div>
                HELLO NASA
            </div>
        </>
    );
};

export default nasaspaceapp;